export enum ProductMetatDataValue {
    DISTRIBUTORELIGIBLE = 'DISTRIBUTORELIGIBLE',
    FREE_PRODUCT_ELIGIBLE = 'FREE_PRODUCT_ELIGIBLE',
    FEATURED_PAK = 'FEATURED_PAK',
    DEPOSIT_FEE_ENABLED = "DEPOSIT_FEE_ENABLED",
    DEPOSIT_FEE_PRODUCT = "DEPOSIT_FEE_PRODUCT",
    BONDED_WAREHOUSE_PRODUCT = "BONDED_WAREHOUSE_PRODUCT"
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/product-metadata.enum.ts